// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fRUVLkElOdoKCk_GCypB{color:#56a4b4}.fRUVLkElOdoKCk_GCypB,.WmE1DbB28yDql3tVZyPl{font-size:14px}`, "",{"version":3,"sources":["webpack://./ui-kit/ITooltip/TitleFromTooltip/TitleFromTooltip.module.scss"],"names":[],"mappings":"AACE,sBACE,aAAA,CAEF,4CACE,cAAA","sourcesContent":[".content {\r\n  &__title {\r\n    color: #56a4b4;\r\n  }\r\n  &__title, &__description {\r\n    font-size: 14px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content__title": `fRUVLkElOdoKCk_GCypB`,
	"content__description": `WmE1DbB28yDql3tVZyPl`
};
export default ___CSS_LOADER_EXPORT___;
